<template>
    <div class="c-result-stat-incorrect">
        <div class="wr-result-stat-incorrect-labels">
            <svg class="c-result-stat-incorrect__icon" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.567 11.366l-4.37-4.365 4.37-4.364A1.544 1.544 0 1011.384.452L7.01 4.82 2.636.452A1.544 1.544 0 10.453 2.637L4.823 7l-4.37 4.365a1.544 1.544 0 102.183 2.185L7.01 9.183l4.374 4.368c.301.3.696.45 1.092.45a1.543 1.543 0 001.091-2.635z" fill="#708BB1"/></svg>
            <span class="c-result-stat-incorrect__label">YANLIŞ</span>
        </div>
        <div class="wr-result-stat-incorrect-value">
            <span class="c-result-stat-incorrect__value">x{{incorrectValue}}</span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            incorrectValue: { type: Number, default: 4 },
        }
    };
</script>

<style scoped src="@/css/components/c-result-stat-incorrect.css"></style>